import { render, staticRenderFns } from "./DoctorItem.vue?vue&type=template&id=e3c1ce1e&scoped=true"
import script from "./DoctorItem.vue?vue&type=script&lang=js"
export * from "./DoctorItem.vue?vue&type=script&lang=js"
import style0 from "./DoctorItem.vue?vue&type=style&index=0&id=e3c1ce1e&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3c1ce1e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\daima\\daima\\health-store\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e3c1ce1e')) {
      api.createRecord('e3c1ce1e', component.options)
    } else {
      api.reload('e3c1ce1e', component.options)
    }
    module.hot.accept("./DoctorItem.vue?vue&type=template&id=e3c1ce1e&scoped=true", function () {
      api.rerender('e3c1ce1e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/business/page/treatment/enroll/copm/DoctorItem.vue"
export default component.exports